import { formatCTAS } from "../../functions";
import { CTAWrapper, BUTTON_STYLES, BUTTON_VARIANTS } from "../../components/CTA";

export const RelevantServices = ({ ctas, displayRelevantServicesMenu, siteStatus, isStatic, parsedFunctions }) => {
	const relevantServices = formatCTAS(ctas, siteStatus, isStatic);
	if (displayRelevantServicesMenu === false) {
		return (
			<div className="flex flex-col lg:flex-row gap-[1rem] md:gap-3 w-[100%] items-center m-auto py-4 px-6 [&>button]:w-[100%] [&>button]:max-w-[400px] md:px-0 ">
				{relevantServices.map((cta, index) => (
					<CTAWrapper
						key={index}
						cta={cta}
						siteStatus={siteStatus}
						parsedFunctions={parsedFunctions}
					/>
				))}
			</div>
		);
	}
	return (
		<div className="flex flex-col gap-3 w-full md:w-[70%] items-start m-auto lg:ml-0 pt-8 pb-6 px-4 [&_button]:w-full md:px-0 ">
			<h3 className="w-full py-0 mb-1">Relevant Services:</h3>
			{relevantServices.map(cta => (
				<CTAWrapper
					key={cta.title}
					fullWidth={true}
					cta={{
						...cta,
						variant: BUTTON_VARIANTS.PRIMARY,
						buttonStyling: [BUTTON_STYLES.ROUNDED, BUTTON_STYLES.WHITE_OUTLINE],
					}}
					parsedFunctions={parsedFunctions}
				/>
			))}
		</div>
	);
};
